export default {
  splitHour: (state, getters, rootState, rootGetters) => (hour) => {
    return rootGetters['event/splitHour'](hour)
  },

  splitMinute: (state, getters, rootState, rootGetters) => (minute) => {
    return rootGetters['event/splitMinute'](minute)
  }
}

